// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLEROPEDIA_MORE_ARTICLES = "Zobraz \u010fal\u0161ie \u010dl\u00e1nky";
